<div class="flyout-consent-list-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'consent-list'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/consent.svg" width="32px" height="32px" />
        <span>{{ "flyout.general.consents" | translate }}</span>
      </mat-expansion-panel-header>

      @for (consent of consentsToShow; track consent) {
        <div class="expansion-panel-row values">
          <div>
            <div class="row-title">
              <a [href]="consent.latestConsent.privacyPolicyUrl" target="_blank" rel="noopener noreferrer">
                <span>{{ "generic.version" | translate }}:</span>
                <span>{{ consent.latestConsent.formattedVersionDate }}</span>
                <span>, {{ "generic.revision" | translate }}:&nbsp;</span>
                <span>{{ consent.latestConsent.revisionNumber }}</span>
                <mat-icon>open_in_new</mat-icon>
              </a>
            </div>
            <div>{{ "flyout.consent.given-consent" | translate }}{{ consent.timesConsented }}{{ "flyout.consent.times" | translate }}</div>
            <div class="row-sub-title">
              {{ "flyout.consent.latest" | translate }}{{ consent.latestConsent.formattedTimestamp }}, "{{ consent.latestConsent.title }}"
            </div>
            <div class="row-description">{{ consent.latestConsent.privacyPolicyText }}</div>
            <a
              class="row-url"
              [href]="consent.latestConsent.currentWebsiteUrl"
              [innerHTML]="consent.latestConsent.currentWebsiteUrl"
              target="_blank"
              rel="noopener noreferrer"></a>
            @if (consent.timesConsented > 1) {
              <div>
                <div class="row-sub-title">
                  {{ "flyout.consent.first" | translate }}{{ consent.firstConsent.formattedTimestamp }}, "{{ consent.firstConsent.title }}"
                </div>
                <div class="row-description">{{ consent.firstConsent.privacyPolicyText }}</div>
                <a
                  class="row-url"
                  [href]="consent.firstConsent.currentWebsiteUrl"
                  [innerHTML]="consent.firstConsent.currentWebsiteUrl"
                  target="_blank"
                  rel="noopener noreferrer"></a>
              </div>
            }
          </div>
          <!--<div *ngIf="action.actionType !== SessionActionTypes.Pageview
            && action.actionType !== SessionActionTypes.Click
            && action.actionType !== SessionActionTypes.WidgetConversion
            && action.actionType !== SessionActionTypes.WidgetClickthrough
            && action.actionType !== SessionActionTypes.WidgetOpen
            && action.actionType !== SessionActionTypes.Goal">
          {{action.actionType}}
        </div>-->
        </div>
      }
      @if (displayConsents.length > 2) {
        <div class="expansion-panel-row pagination">
          <div class="navigation" (click)="navigateConsents(false)">
            <span>
              <mat-icon>arrow_back</mat-icon>
              {{ "generic.previous" | translate }}
            </span>
          </div>
          <span>{{ spanStart }} - {{ spanEnd }} {{ "generic.of" | translate }} {{ displayConsents.length }}</span>
          <div class="navigation" (click)="navigateConsents(true)">
            <span>
              {{ "generic.next" | translate }}
              <mat-icon>arrow_forward</mat-icon>
            </span>
          </div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
